
import styled from "styled-components"

const Container = styled.div`
    width: ${({containerWidth}) => containerWidth};
    display: flex;
    color: ${({theme}) => theme.mainTextColor};

`

const MenuItem = styled.div`
        flex: 1;
        padding: 10px;
        border-bottom: 2px solid ${({theme, isActive}) => isActive ? "var(--color-main)" : theme.secondaryBgColor};
        color: ${({theme, isActive}) => isActive ? "var(--color-main)" : theme.mainTextColor};
        background-color: ${({theme, isActive}) => isActive ? "rgba(232, 86, 70, .08)" : theme.mainBgColor};
        text-align: center;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        cursor: pointer;
`



const TopMenus = ({activeMenuId, setActiveMenuId, menuList, containerWidth="100%"}) => {
  return (
    <Container containerWidth={containerWidth}>
        {
            menuList.map((item) => (
                <MenuItem isActive={activeMenuId === item.id} onClick={() => setActiveMenuId(item.id)} key={item.id}>{item.text}</MenuItem>
            ))
        }
    </Container>
  )
}

export default TopMenus